import type { NavigationRect } from "./navigation-layout";

export interface ScreenRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function markerOverlap(a: ScreenRect, b: ScreenRect): boolean {
  return (
    a.x < b.x + b.width + 8 &&
    a.x + a.width + 8 > b.x &&
    a.y < b.y + b.height + 8 &&
    a.y + a.height + 8 > b.y
  );
}

export function partyBadgePosition(
  safe: NavigationRect,
  width: number,
  height: number,
  occupied?: ScreenRect,
): ScreenRect | undefined {
  const positions = [
    { x: safe.left + 6, y: safe.bottom - height - 6 },
    { x: safe.right - width - 6, y: safe.top + 6 },
    { x: safe.left + 6, y: safe.top + 6 },
    { x: safe.right - width - 6, y: safe.bottom - height - 6 },
  ];
  return positions
    .map((point) => ({ ...point, width, height }))
    .find(
      (rect) =>
        rect.x >= safe.left &&
        rect.x + width <= safe.right &&
        rect.y >= safe.top &&
        rect.y + height <= safe.bottom &&
        (!occupied || !markerOverlap(rect, occupied)),
    );
}
